module.exports = __webpack_public_path__ + "static/phone-f712587ea42bda87174ab2a7ead452f0.png";